import { Brand } from './index';

export class PhoneList {
  brands;
  highlights;
  // Map<string, Brand>;

  constructor({highlightedPhones, phoneList, meta}) {
    this.initBrands(phoneList);
    // console.log(this.brands.get('apple').phones.get('iphone-3g').variants.get('192'));
    const mockHilights = [
      {
        brandId: 'apple',
        phoneId: 'iphone-3g',
        variantId: '192'
      }
    ];
    this.initHighlights(mockHilights);

    // this.initHighlights(highlightedPhones);
    // console.log(this.brands, this.brands.values());
    // console.log(this.b);
  }

  initBrands(phoneList) {
    const mapItems = phoneList.brands.map(m => [m.id, new Brand(m)]);
    this.brands = new Map(mapItems);
  }

  initHighlights(highlights) {
    const mapItems = highlights.map(v => {
      return [
          v.variantId,
          this.brands.get(v.brandId).phones.get(v.phoneId).variants.get(v.variantId)
        ];
      });
    this.highlights = new Map(mapItems);
    // console.log(this.highlights);
  }

  // loaighlights() {
  //   const variants = this._highlights.map(
  //     (highlight) => {
  //       return this.findPhone(highlight.brandId, highlight.phoneId);
  //     });
  //   return variants;
  // }

  // findPhone(brandId, phoneId): Phone {
  //   // debugger;
  //   let brand = this.brands.find((b) => b.id === brandId);
  //   return brand.phones.find((p) => p.id === phoneId);
  // }

  // getPhoneIndexFromBrandList(brand. phoneId) {

  // }

  // getBrandById(brandId: string): Brand {
  //   return this.brands.find(b => b.id === brandId);
  // }

  // findPhonesByBrandId(brandId: string) {
  //   return this.getBrandById(brandId).phones;
  // }

  // getSuggestedPhones(phone: Phone) {
  //   let bettePhonesSameBrand;
  //   let suggestedPhones;
  //   const brand = this.findBrandById(phone.brandId);
  //   const phoneIndex = brand.phones.findIndex(p => p.id === phone.id);
  //   if (~phoneIndex  && phoneIndex < brand.phones.length - 1) {
  //     // Is not the newest model, add the newes model to the suggested phones array
  //     bettePhonesSameBrand = <Phone[]>[...brand.phones];
  //     bettePhonesSameBrand.splice(phoneIndex - 1);
  //   }
  //   suggestedPhones = {
  //     sameBrand: bettePhonesSameBrand,
  //     differentBrand: this.getNewerPhones(phone)
  //   };
  //   console.log(suggestedPhones);
  //   return suggestedPhones;
  // }

  // getNewerPhones(phone: Phone): Phone[] {
  //   const phonePrice = phone.currentPrice;
  //   let betterPhones: Phone[] = [];
  //   // Scan the whole DB
  //   console.time('Find better phones');
  //   this.brands.forEach(b => {
  //     if (phone.brandId !== b.id) {
  //       b.phones.forEach(p => {
  //         if (p.currentPrice > phone.currentPrice) {
  //           betterPhones.push(p);
  //         }
  //       });
  //     }
  //   });
  //   betterPhones.sort((p1, p2) => (p1.currentPrice < p2.currentPrice) ? 1 : -1);
  //   console.timeEnd('Find better phones');
  //   console.log('betterPhones', betterPhones);
  //   return betterPhones;
  // }

  // findPhoneIndexById



  // get brandNames() {
  //   return this.brands.map(b => b.id);
  // }

  // getBrandPhones(brand: Brand){
  //   return brand.phoneNames;
  // }

  // makeBrandModelArray(response) {
  //   console.log(response);
  //   this._brands = response.phones.brands
  // }

  // get brandNames() {
  //   return this._brands.map(brand => brand.id);
  // }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/models/phone-list.ts